import { useGetMyStudyParticipantsMeStudyGet } from "@/api-v3";
import { useIsLogin } from "@/router/hooks/use-is-login";

/** Returns the languages that the study is using */
export function useStudyLanguages(forceGet?: boolean) {
  const isLogin = useIsLogin();

  const { data: studyLanguages } = useGetMyStudyParticipantsMeStudyGet({
    query: {
      select: (data) => data?.languages?.map((lan) => lan.toLowerCase()),
      enabled: !isLogin || forceGet === true,
    },
  });

  return { studyLanguages };
}
